export function compareBootSeq(a, b) {
    if (a.boot !== b.boot)
        return a.boot < b.boot ? -1 : 1;
    if (a.seq !== b.seq)
        return a.seq < b.seq ? -1 : 1;
    return 0;
}
/** True if candidate is newer than current (anything is newer than nothing). */
export function isNewer(candidate, current) {
    return current == null || compareBootSeq(candidate, current) > 0;
}
/** Keeps the latest (boot, seq) per key (e.g. per state group) and accepts only newer messages. */
export class NewerOnly {
    latestByKey = new Map();
    /** Records and returns true if position is newer than the last accepted one for key. */
    accept(key, position) {
        if (!isNewer(position, this.latestByKey.get(key)))
            return false;
        this.latestByKey.set(key, { boot: position.boot, seq: position.seq });
        return true;
    }
    latest(key) {
        return this.latestByKey.get(key);
    }
    /** Forgets everything (e.g. after a new coupling) or one key (e.g. a retained topic cleared by an empty payload). */
    reset(key) {
        if (key === undefined)
            this.latestByKey.clear();
        else
            this.latestByKey.delete(key);
    }
}
//# sourceMappingURL=order.js.map